import { receiptSearch } from '../../services/AsadaApi';

const doReceiptSearch = (nombre, cedula, paja, handleResult) => {
  receiptSearch(nombre, cedula, paja, handleResult);
}

export default doReceiptSearch;